import config from "../config"
export default {
    data(){
        return {
            oss: config.ossUrl
        }
    }
}